import { useEffect, useState } from 'react';
export function RecoveryCodes({ codes, login, onDone }: { codes: string[]; login: string; onDone: () => void }) {
  const [saved, setSaved] = useState(false);
  const [message, setMessage] = useState('');
  const [createdAt] = useState(() => new Date().toISOString());
  useEffect(() => {
    if (saved) return;
    const warn = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [saved]);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(codes.join('\n'));
      setMessage('すべてコピーしました');
    } catch {
      setMessage('コピーできませんでした。ファイルに保存するか、コードを手動でコピーしてください。');
    }
  };
  const download = () => {
    const text = [
      'mc-panel のリカバリーコード',
      'ログイン ID: ' + login,
      '作成日時: ' + createdAt,
      'URL のホスト: ' + location.host,
      '',
      ...codes,
      '',
      '各コードは 1 回だけ使えます',
      '',
    ].join('\n');
    const url = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = 'mc-panel-recovery-codes-' + login + '.txt';
    document.body.append(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 0);
  };
  return (
    <div className="stack">
      <h3>リカバリーコード</h3>
      <p>今だけ表示されます。安全な場所に保存してください。各コードは 1 回だけ、ログインや再確認に使えます。</p>
      <pre>{codes.join('\n')}</pre>
      <div className="row">
        <button className="btn" type="button" onClick={() => void copy()}>
          すべてコピー
        </button>
        <button className="btn" type="button" onClick={download}>
          ファイルに保存（.txt）
        </button>
      </div>
      {message && <p role="status">{message}</p>}
      <label className="check">
        <input type="checkbox" checked={saved} onChange={(e) => setSaved(e.target.checked)} />
        コードを安全な場所に保存しました
      </label>
      <button className="btn primary" type="button" disabled={!saved} onClick={onDone}>
        完了
      </button>
    </div>
  );
}
